import { render, staticRenderFns } from "./AvatarDropdown.vue?vue&type=template&id=552d2694&scoped=true&"
import script from "./AvatarDropdown.vue?vue&type=script&lang=js&"
export * from "./AvatarDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AvatarDropdown.vue?vue&type=style&index=0&id=552d2694&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552d2694",
  null
  
)

export default component.exports